<div class="row" *ngIf="customerID > 0">
    <div class="col-sm-12">
        <kendo-expansionpanel [title]="'Action'"
                              [subtitle]="''"
                              [disabled]="false"
                              [expanded]="true">
            <div class="row">
                <div class="col">
                    <label class="font-weight-bold">Action Type</label>
                    <select name="actionTypeID" [(ngModel)]="customerAction.actionTypeID" class="form-select" required>
                        <option *ngFor="let actionType of actionTypeList" value="{{actionType.actionTypeId}}">{{actionType.actionTypeDescription}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="font-weight-bold">Event Date</label>
                    <br />
                    <kendo-datepicker name="eventDate" [(ngModel)]="customerAction.eventDate" [format]="'MM/dd/yy'"
                                      [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('eventDate')" required>
                    </kendo-datepicker>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="font-weight-bold">Contact</label>
                    <select name="contactID" [(ngModel)]="customerAction.contactID" class="form-select" (change)="contactChange($event)">
                        <option value=""></option>
                        <option *ngFor="let contact of contactList" value="{{contact.contactID}}">{{contact.contactName}}</option>
                    </select>
                </div>
                <div class="col-sm-1">
                    <button (click)="addContact('Customer')" class="btn btn-sml btn-primary" title="Add Contact"><i class="fas fa-plus"></i></button>
                </div>
                <div class="col-sm-1">
                    <button (click)="editContact('Customer')" class="btn btn-sml btn-success" title="Edit Contact" *ngIf="customerAction.contactID>0"><i class="fas fa-pencil-alt"></i></button>
                </div>
            </div>
            <div class="row" *ngIf="isAddContact">
                <div class="col-sm-12 border border-primary bg-light m-2">
                    <contact-quick-add [tableID]="customerAction.customerID" [contactTitleID]="2" [contactType]="'Customer'" [countryCode]="countryCode" (onRefreshContact)="refreshContacts($event, 'Customer')"></contact-quick-add>
                </div>
            </div>
            <div class="row" *ngIf="isEditContact">
                <div class="col-sm-12 border border-primary bg-light m-2">
                    <contact-quick-edit [contactID]="customerAction.contactID" (onRefreshContact)="refreshContacts($event, 'Customer')"></contact-quick-edit>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="font-weight-bold">Details</label>
                    <kendo-textarea style="width:100%" id="customerActionNotes"
                                    resizable="auto"
                                    [(ngModel)]="customerAction.customerActionNotes"
                                    [value]="customerAction.customerActionNotes" required>
                    </kendo-textarea>
                    <!--<textarea class="form-control" id="customerActionNotes" [(ngModel)]="customerAction.customerActionNotes" required></textarea>-->
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <div><input type="checkbox" rows="3" [(ngModel)]="customerAction.followUpInd" (change)="toggleFollowUp()" stylestyle="transform:scale(1.5);margin-right:5px;" /> Follow Up</div>
                </div>
                <div class="col">
                    <label class="font-weight-bold">Follow Up Date</label>
                    <br />
                    <kendo-datepicker name="eventDate" [(ngModel)]="customerAction.followUpDate" [format]="'MM/dd/yy'"
                                      [ngModelOptions]="{standalone: true}" (valueChange)="dateChanged('followUpDate')"
                                      [disabled]="customerAction.followUpInd!=true" required>
                    </kendo-datepicker>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="font-weight-bold">Assign To</label>
                    <select name="followUpEmployeeID" [(ngModel)]="customerAction.followUpEmployeeID"
                            class="form-select" [disabled]="customerAction.followUpInd!=true">
                        <option *ngFor="let emp of employeeList" value="{{emp.employeeId}}">{{emp.fullName}}</option>
                    </select>
                </div>
            </div>
            <div class="row" *ngIf="customerID > 0">
                <div class="col">
                    <label class="font-weight-bold">Opportunity</label>
                    <select name="opportunityID" class="form-select" [(ngModel)]="customerAction.opportunityId">
                        <option value="-1">- Select Opportunity -</option>
                        <option *ngFor="let item of opportunityList" value="{{item.opportunityID}}">{{item.notes}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <label class="font-weight-bold">Sales Cycle</label>
                    <select name="customerStatusId" [(ngModel)]="customer.customerStatusId"
                            class="form-select" [disabled]="customerActionID>0">
                        <option *ngFor="let status of customerStatusList" value="{{status.customerStatusId}}">{{status.stage}}: {{status.description}}</option>
                    </select>
                </div>
            </div>
            <div class="row">
                <div class="col m-2 text-end">
                    <button class="btn btn-primary m-2" (click)="save()">Save</button>
                    <button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>
                </div>
            </div>
        </kendo-expansionpanel>
    </div>
</div>
